import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const PromotionalMaterial = () => {
  return (
    <div className="bg-[#FFFFFF] min-h-screen">

  

      <div className="p-8">

        {/* Header Section */}
        <div className="flex justify-between items-center mb-8">
          
          {/* Left */}
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full border flex items-center justify-center">
              <ArrowBackIcon sx={{cursor:"pointer"}} onClick={() => window.history.back()} />
            </div>

            <div>
              <h2 className="text-xl font-semibold">
                Promotional Material
              </h2>
              <p className="text-gray-500 text-sm">
                Poster, Video, Banner, Brochures & PPTs
              </p>
            </div>
          </div>

          {/* Right */}
          <div className="flex gap-4">
            <input
              type="text"
              placeholder="Search"
              className="border rounded-md px-4 py-2 w-72 bg-white"
            />

            <select className="border rounded-md px-4 py-2 bg-white">
              <option>Source Type</option>
            </select>
          </div>
        </div>

        {/* Grid Layout */}
        <div className="grid grid-cols-3 gap-6">

          {/* Left Column */}
          <div className="flex flex-col gap-6">
            <Card label="BROCHURE" />
            <Card label="BANNER" />
          </div>

          {/* Middle Column */}
          <Card label="POSTER" className="h-[700px]" />

          {/* Right Column (Video) */}
          <VideoCard />
        </div>
      </div>
    </div>
  );
};

export default PromotionalMaterial;


/* ---------- Card ---------- */

const Card = ({ label, className = "" }) => {
  return (
    <div
      className={`bg-[#FFF2F0] rounded-xl flex items-center justify-center 
      text-gray-600 font-semibold text-lg ${className} h-[338px]`}
    >
      {label}
    </div>
  );
};


/* ---------- Video Card ---------- */

const VideoCard = () => {
  return (
    <div className="bg-[#FFF2F0] rounded-xl h-[700px] flex flex-col justify-between p-6">
      
      {/* Play Center */}
      <div className="flex-1 flex items-center justify-center">
        <div className="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center">
          <PlayArrowIcon sx={{ fontSize: 40, color: "#888" }} />
        </div>
      </div>

      {/* Progress Bar */}
      <div className="w-full h-1 bg-gray-300 rounded-full relative">
        <div className="absolute left-10 top-1/2 -translate-y-1/2 w-3 h-3 bg-gray-600 rounded-full"></div>
      </div>
    </div>
  );
};